import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Space, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import {  useNavigate } from 'react-router-dom';
import Axios from '../../../services/AxiosInterceptor';


const ServiceList = () => {
  const [list,setList]=useState();
  const navigate=useNavigate()

  const getServiceList = async () => {
  try {
    const response = await Axios.get("api/service-list");

    const data = response.data; // Axios already parsed JSON

    const reverseData = Array.isArray(data) ? [...data].reverse() : data;

    setList(reverseData);

  } catch (error) {
    console.error("Error fetching location list:", error);
  }
};

  console.log(list)

  useEffect(() => {
    getServiceList();
  }, []);

  const handleEdit=(record)=>{
    // Check if it's a subscription service
    if(record.is_subscription === true){
      navigate(`/Edit-Subscription/${record._id}`)
    } else {
      navigate(`/Editservice/${record._id}`)
    }
  }
 const handleDelete = async (id) => {
  console.log(id);

  try {
    const response = await Axios.post(
      "api/service-list-delete",
      { id: id }, // <-- real data sent here
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    if (response.data) {
      window.location.reload();
    }

  } catch (error) {
    console.error("Delete failed", error);
  }
};

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Session Type",
      dataIndex: "sessionType",
      key: "sessionType",
    },
    {
      title: "Price & Discount",
      render: (record) => {
        const price = record?.pricing?.amount;
        const discount = record?.pricing?.discount;
  
        return (
          <div>
            <p>₹{price}</p>
            {discount ? (
              <small style={{ color: "green" }}>({discount}% off)</small>
            ) : null}
          </div>
        );
      },
    },
    {
      title: "Class Mode",
      dataIndex: "classMode",
      key: "classMode",
    },
    {
      title: "Type",
      key: "type",
      render: (record) => {
        return (
          <div>
            {record.is_subscription ? (
              <span style={{ 
                backgroundColor: "#52c41a", 
                color: "white", 
                padding: "4px 12px", 
                borderRadius: "4px",
                fontWeight: "500"
              }}>
                Subscription
              </span>
            ) : (
              <span style={{ 
                backgroundColor: "#1890ff", 
                color: "white", 
                padding: "4px 12px", 
                borderRadius: "4px",
                fontWeight: "500"
              }}>
                Regular Service
              </span>
            )}
          </div>
        );
      },
    },
    {
      title: "Status",
      key: "serviceStatus",
      render: (record) => {
        const isExpired = record.status === 'Expired';
        return (
          <span style={{ 
            backgroundColor: isExpired ? "#ff4d4f" : "#52c41a", 
            color: "white", 
            padding: "4px 12px", 
            borderRadius: "4px",
            fontWeight: "500"
          }}>
            {isExpired ? "Expired" : "Active"}
          </span>
        );
      },
    },
    {
    title: "Location",
    render: (record) => {
      return record.locations?.map(loc => loc.name).join(", ");
    },
  },
    {
        title: "Action",
        key: "action",
        render: (text, record) => (
          <Space size="middle">
            <Button 
              icon={<EditOutlined />} 
              onClick={() => handleEdit(record)} 
              type="primary"
            >
              Edit
            </Button>
            <Button 
              icon={<DeleteOutlined />} 
              onClick={() => handleDelete(record._id)} 
              danger
            >
              Delete
            </Button>
          </Space>
        ),
      },
    
  ];
  
  const handleAdd=()=>{
    navigate("/addservice")
  }
   const handleSubscription=()=>{
    navigate("/AddSubscription/")
  }


  return (
    <div>
 <h3>Service Lists</h3>
 <Button onClick={handleAdd}>Add Service</Button>
  <Button onClick={handleSubscription}>Add Subscription</Button>

      <Table
        columns={columns} 
        dataSource={list}
        rowKey="_id" 
        pagination={false} 
      />
    </div>
  )
}
export default ServiceList;
